import { HTTP } from "@/utils/http-common"

export default {
  async getAll(queryArgs = null) {
    const path = `/account/admin/actions`
    let results = (await HTTP.get(path, { params: queryArgs })).data
    results.sort((a, b) => {
      return a.name.localeCompare(b.name)
    })
    return results
  },

  async get(actionId) {
    const path = `/account/admin/actions/${actionId}`
    return (await HTTP.get(path)).data
  },

  async post(data) {
    const path = `/account/admin/actions`
    return (await HTTP.post(path, data)).data
  },

  async put(data) {
    const { id, ...others } = data
    const path = `/account/admin/actions/${id}`
    return (await HTTP.put(path, others)).data
  },

  async delete(actionId) {
    const path = `/account/admin/actions/${actionId}`
    return (await HTTP.delete(path)).data
  }
}
